export default __webpack_public_path__ + "static/media/I0000.1d469721.png";